import { FormField, WithFormField } from '@shared/forms/components/FormField';

import { SelectInput, SelectInputProps } from './SelectInput';

export function SelectField({ name, label, required, ...props }: WithFormField<SelectInputProps>) {
  return (
    <FormField name={name} label={label} required={required}>
      {(field) => <SelectInput {...field} {...props} />}
    </FormField>
  );
}
